<template>
  <div class="side-nav">
    <b-dropdown
      variant="outline-danger"
      size="sm"
      split
      :text="trans(organization.is_editing_microsite ? 'exit_design_mode' : 'design_mode')"
      @click="onClickDesignMode"
    >
      <b-dropdown-item v-if="organization.is_editing_microsite" v-b-modal.page-modal>
        <i class="fa fa-fw fa-plus"></i>
        {{ trans('page') }}
      </b-dropdown-item>
      <b-dropdown-item v-if="organization.is_editing_microsite" v-b-modal.admin-iframe-embed-modal>
        <i class="fa fa-fw fa-code"></i>
        {{ trans('embed_on_your_website') }}
      </b-dropdown-item>
      <b-dropdown-item v-if="organization.is_editing_microsite" v-b-modal.page-reorder-modal>
        <i class="fa fa-fw fa-bars"></i>
        {{ trans('reorder_pages') }}
      </b-dropdown-item>
      <b-dropdown-divider v-if="organization.is_editing_microsite"></b-dropdown-divider>
      <b-dropdown-item
        v-b-modal.admin-carts-modal
      >
        <i class="fa fa-fw fa-shopping-cart"></i>
        {{ trans('admin_carts') }}
      </b-dropdown-item>
      <b-dropdown-item
        :href="`/organization/${organization.id}/invoice`"
        :target="!!iframeUrlPrefix ? '_blank' : null"
      >
        <i class="fa fa-fw fa-coffee"></i>
        {{ trans('admin_portal') }}
      </b-dropdown-item>
    </b-dropdown>

    <admin-carts-modal
      v-if="organization.auth_user"
      :organization="organization"
      :invoice="invoice"
    ></admin-carts-modal>
    <admin-iframe-embed-modal
      id="admin-iframe-embed-modal"
      :organization="organization"
    ></admin-iframe-embed-modal>
  </div>
</template>

<script>
  import TestModeSwitch from './../../../common/components/TestModeSwitch'
  import AdminCartsModal from './AdminCartsModal'
  import AdminIframeEmbedModal from './../microsite-designer/PageIframeEmbedModal'
  import CartLink from './CartLink'

  export default {
    props: {
      organization: Object,
      invoice: Object,
      currentPage: Object,
    },
    components: {
      TestModeSwitch,
      AdminCartsModal,
      AdminIframeEmbedModal,
      CartLink,
    },
    data() {
      return {
        trans: trans,
        iframeUrlPrefix: _.iframeUrlPrefix,
        busy: false,
        error: null,
      }
    },
    methods: {
      onClickDesignMode() {
        this.busy = true
        this.error = null
        const url = `/org/${this.organization.id}/design_mode`
        axios.post(url, {
          is_editing_microsite: !this.organization.is_editing_microsite
        })
        .then(response => {
          window.location.reload()
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          _.toastError(this, this.error)
        })
      },
    },
    mounted() {
      window.adminOptions = this
    },
  }
</script>